export const mapCommPref = (
  commPref: string | undefined,
  isInBranch: boolean,
  isOnline: boolean,
): string | undefined => {
  if (isInBranch) return 'in person';
  if (isOnline && commPref === 'Video Conference') return 'video conference';
  if (isOnline) return 'phone'; // Default for online appointments
  return undefined; // Don't know appointment type
};
